const NousSoutenirFeaturesSlider = (target) => {
  const sliderParams = {
    arrows: false,
    dots: true,
    infinite: false,
    variableWidth: true,
    swipeToSlide: true,
    mobileFirst: true,
    responsive: [{
      breakpoint: 768,
      settings: 'unslick',
    }],
  };

  const initSlider = ($el, params) => {
    $el.slick(params);
  };

  $('body').find(target).each((_, el) => {
    const $el = $(el);
    const params = $.extend({}, sliderParams, $el.data('slider-params'))

    initSlider($el, params);

    $(window).on('resize', function() {
      if($(window).width() < 768 && !$el.hasClass('slick-initialized')) {
        $el.slick(params);
      }
    });
  });
}

export default NousSoutenirFeaturesSlider;



// WEBPACK FOOTER //
// ./scripts/components/NousSoutenirFeaturesSlider.js